import { canonicalGrassKeys, grassAliases } from './normalization'
import { sunlightReference } from './rules'
import { RULE_SOURCES } from './sources'
import { toolCoverageReference } from './tool-adapter'
import { LAWN_PLAN_ENGINE_VERSION } from './types'

export function getLawnEngineReference() {
  return {
    engineVersion: LAWN_PLAN_ENGINE_VERSION,
    deterministic: true,
    grassTypes: canonicalGrassKeys(),
    grassAliases: grassAliases(),
    ambiguousGrassTypes: {
      Fescue: ['Tall Fescue', 'Fine Fescue'],
    },
    sunlightBands: sunlightReference(),
    lawnSizeParsing: {
      exact: ['3500', '3,500', '3500 sq ft', '3.5k'],
      buckets: {
        small: 1500,
        medium: 3500,
        large: 7500,
        xl: 12000,
      },
      gallonsFormula: 'sqft * inches * 0.623',
      fertilizerFormula: '(target pounds N per 1000 sq ft / nitrogen percent as decimal) * (sqft / 1000)',
    },
    toolCoverage: toolCoverageReference(),
    ruleSources: RULE_SOURCES,
  }
}
